import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  TextField,
  Button,
  CircularProgress,
  Card,
  CardContent,
  CardHeader,
  Link,
  Typography,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import { MySnackbar } from "../../components/mySnackbar/MySnackbar";
import AppContext from "../../components/appContext";
import rest from "../../rest";
import useStyles from "./ResetPasswordStyle";
import useStylesThemes from "../../components/css/globalTheme";
import { useSelector } from "react-redux";
import ForgotPassword from "../../components/forgotPassword/ForgotPassword";

const ResetPassword = () => {
  const classes = useStyles();
  const styleTheme = useStylesThemes()();

  const myContext = useContext(AppContext);
  const location = useLocation();
  const history = useHistory();
  const [snack, setSnack] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [infoUser, setInfoUser] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const logo = useSelector((state) => state.manif.manifInfos.Logo);
  const logoManif = `data:image/png;base64,${logo}`;

  // Extraction du token à partir de l'URL
  const query = new URLSearchParams(location.search);
  const token = query.get("token");

  // Ferme le sidebar à l'ouverture de la page
  useEffect(() => {
    myContext.setOpenSidebar(false);
    // eslint-disable-next-line
  }, []);

  // Récupérer les infos de l'utilisateur en fonction du token.
  useEffect(() => {
    setLoading(true);

    rest
      .post("/4DACTION/ACCOUNT_GestionCompte2", {
        vAction: "getInfosUserByToken",
        vToken: token,
      })
      .then(function (response) {
        if (response.data.error === false) {
          setShowForm(true);
          setSnack({
            show: true,
            message: response.data.message,
            severity: "info",
          });
        }
        setInfoUser({ ...response.data.infos, Message: response.data.message });
        setLoading(false);
      });
  }, [token]);

  const handleForgetPassword = () => {
    setOpenForgotPassword(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);

    rest
      .post("/4DACTION/ACCOUNT_GestionCompte2", {
        token: token,
        newPassword: password,
        vAction: "ResetPassword",
      })
      .then((response) => {
        if (response.data.error === false) {
          setSnack({
            message: response.data.message,
            show: true,
            severity: "success",
          });
          setTimeout(() => {
            history.push("/connexion.html");
          }, 1500);
        } else {
          setError(response.data.message);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Une erreur s'est produite :", error);
        setError("Une erreur inconue s'est produite.");
        setLoading(false);
      });
  };

  return (
    <>
      <LoadingIndicator open={loading} />
      <ForgotPassword
        openDialog={openForgotPassword}
        setOpenDialog={setOpenForgotPassword}
        defaultEmail={infoUser?.Login}
        setEmailSent={setEmailSent}
      />
      <MySnackbar params={snack} />
      <div className={classes.root}>
        {showForm ? (
          <Card className={classes.card}>
            <CardHeader
              titleTypographyProps={{ variant: "h5" }}
              className={classes.cardHeader}
              title={
                <img
                  src={logoManif}
                  alt="Logo"
                  className={classes.titleImage}
                />
              }
            />
            <Typography variant="h5" component="h2" align="center">
              Réinitialisation du mot de passe
            </Typography>
            <CardContent>
              {error && (
                <Alert severity="error" className={classes.alert}>
                  {error}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <TextField
                  label="Login"
                  type="text"
                  fullWidth
                  margin="normal"
                  value={infoUser?.Login || ""}
                  disabled
                  variant="outlined"
                />
                <TextField
                  label="Nouveau mot de passe"
                  type="password"
                  fullWidth
                  margin="normal"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  variant="outlined"
                />
                <TextField
                  label="Confirmer le nouveau mot de passe"
                  type="password"
                  fullWidth
                  margin="normal"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  variant="outlined"
                />
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  fullWidth
                  className={styleTheme.primarybutton}
                  style={{ marginTop: 16 }}
                >
                  {loading ? (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  ) : (
                    "Réinitialiser le mot de passe"
                  )}
                </Button>
              </form>
            </CardContent>
          </Card>
        ) : (
          <Alert severity={emailSent ? "info" : "error"}>
            <AlertTitle>Erreur</AlertTitle>
            {infoUser?.Expire === true ? (
              <>
                Le lien de réinitialisation de mot de passe a expiré.{" "}
                <Link className={classes.link} onClick={handleForgetPassword}>
                  Cliquez ici
                </Link>{" "}
                pour en générer un nouveau.
              </>
            ) : emailSent ? (
              <>
                Un email a été envoyé sur votre adresse email pour réinitialiser
                votre mot de passe.
              </>
            ) : (
              infoUser?.Message || "Une erreur est survenue."
            )}
          </Alert>
        )}
      </div>
    </>
  );
};

export default ResetPassword;
